// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3YdTg","head":"Table_head__1ZoTU","col":"Table_col__17jQ5"};